module.exports = __webpack_public_path__ + "img/activeLeft.ffc33842.svg";